<h3 class="bdo-container re-mb-45">{{ 'contract.overview.title' | translate }}</h3>

<p class="re-container-with-margin re-mb-30 re-text-sm re-leading-m md:re-text-base md:re-leading-2xl">
  {{ 'contract.overview.description' | translate }}
</p>
<div class="bdo-container--single">
  <div [class.re-mb-15]="state === LoadingState.ERROR">
    @if (state === LoadingState.ERROR) {
      <bdo-info-box class="bdo-container--single"
        data-qa="error">
        {{ errorMessage }}
      </bdo-info-box>
    }
  </div>
</div>

<!-- selection of accountId -->
@if (!errorMessage) {
<div class="re-px-20 re-py-15 re-w-full re-bg-white re-relative re-mb-45
            md:re-px-30 md:re-py-20 md:re-w-600 md:re-mx-auto lg:re-mb-90
            lg:re-w-900">
    @if (state === LoadingState.LOADING) {
      <bdo-loading></bdo-loading>
    }
    @if (address) {
      <bdo-accountid-with-address
        [accountId]="selectedAccount?.accountId"
        [address]="Utilities.nestAddress(address)"
      ></bdo-accountid-with-address>
    }
  </div>
}

@if (selectedAccount?.accountId && address) {
  <div class="re-mb-45 md:re-mb-90">
    <bdo-contract-details [accountId]="selectedAccount?.accountId" [address]="address"></bdo-contract-details>
  </div>
}

<!-- New -->
@if (canAddTariff && selectedAccount) {
  <bdo-square-icon-text
    [routerUrl]="'/anmelden/' + selectedAccount?.accountId + '/neu/adresse'"
    [text]="'contract.overview.addTariff' | translate"
    [dataQa]="'contract_new_btn'">
  </bdo-square-icon-text>
}

<!-- FAQ -->
<bdo-faqs
  [keyName]="'contract.overview.faqs'"
  [params]="{ contactLink: reBaseData.hrefContact }"
></bdo-faqs>
